import React from 'react'

const Item = ({Obj,setID,setCode,setType,setValue,setuseCount,setSave}) => {
    const EditFunction = ()=>{
        setID(Obj.id); setCode(Obj.code); 
        if(Obj.type === 1){
            setType({name:'Amount', value:'1'});
        }
        else{
            setType({name:'Percentage', value:'2'});
        }
        setValue(Obj.value); 
        setuseCount(Obj.usecount); setSave('Update');
    }
  return (
    <tr className='discription' onClick={EditFunction} style={{cursor:"pointer"}}>
      <td className='form_item_row_container_item'>
        <p>{Obj.code}</p>
      </td>
      <td className='form_item_row_container_item'>
        <p>{Obj.type}</p>
      </td>
      <td className='form_item_row_container_item'>
        <p>{Obj.value}</p>
      </td>
      <td className='form_item_row_container_item'>
        <p>{Obj.active ? "true":"false"}</p>
      </td>
    </tr>
  )
}

export default Item
